<div class="page-wrapper" *ngIf="customer">
  <div class="search-box">
    <div class="form-control">
      <div class="icon">
        <img src="/assets/img/icons/search.svg" alt="search" />
      </div>
      <input
        type="text"
        placeholder="Search..."
        (input)="searchBuyer()"
        [(ngModel)]="searchString"
      />
    </div>
    <div class="display-options">
      <div
        class="disp-btn display-all"
        [ngClass]="{ 'active-disp-btn': checkDisplaySelection() }"
        (click)="selectColumns()"
      >
        Display All
      </div>
      <div
        class="disp-btn display-filters"
        [ngClass]="{ 'active-disp-btn': !checkDisplaySelection() }"
        [matMenuTriggerFor]="filterOptions"
      >
        <div class="btn-title">
          <span>Display</span>
          <mat-icon>expand_more</mat-icon>
        </div>
        <mat-menu #filterOptions="matMenu">
          <div class="filter-options">
            <div
              class="f-option"
              *ngFor="let col of tableFilterColumns; let i = index"
            >
              <mat-checkbox
                (click)="$event.stopPropagation()"
                [disabled]="lastColumnIndex === i"
                [(ngModel)]="columnsStates[i]"
                (change)="selectColumns(i)"
                >{{ col }}</mat-checkbox
              >
            </div>
          </div>
        </mat-menu>
      </div>
    </div>
    <button mat-button class="add-btn" (click)="toggleBuyerModal()">
      Add New Buyer
    </button>
  </div>

  <div class="table-box">
    <table
      mat-table
      [dataSource]="dataSource"
      class="data-table buyers-table"
    >
      <ng-container matColumnDef="company">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortBuyers('name')"
        >
          <div class="table-header-wrapper">
            COMPANY
            <div class="sort-controls" *ngIf="selectedSort.field === 'name'">
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div class="sort-controls" *ngIf="selectedSort.field !== 'name'">
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let buyer"
          class="customer-name"
          (click)="selectBuyer(buyer); toggleBuyerModal()"
        >
          <div class="company-info" [title]="buyer.name">
            {{ buyer.name }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="person">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortBuyers('lastName')"
        >
          <div class="table-header-wrapper">
            PERSON
            <div
              class="sort-controls"
              *ngIf="selectedSort.field === 'lastName'"
            >
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div
              class="sort-controls"
              *ngIf="selectedSort.field !== 'lastName'"
            >
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let buyer"
          class="users"
          (click)="selectBuyer(buyer); toggleBuyerModal()"
        >
          <div class="user-name">
            {{ buyer.firstName }} {{ buyer.lastName }}
          </div>
          <div class="user-email">
            {{ buyer.email }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortBuyers('phone')"
        >
          <div class="table-header-wrapper">
            PHONE
            <div class="sort-controls" *ngIf="selectedSort.field === 'phone'">
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div class="sort-controls" *ngIf="selectedSort.field !== 'phone'">
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let buyer"
          class="buyer-phone"
          (click)="selectBuyer(buyer); toggleBuyerModal()"
        >
          <div class="phone">
            {{ buyer.phone }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="destination country">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortBuyers('country.name')"
        >
          <div class="table-header-wrapper">
            DESTINATION COUNTRY
            <div
              class="sort-controls"
              *ngIf="selectedSort.field === 'country.name'"
            >
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div
              class="sort-controls"
              *ngIf="selectedSort.field !== 'country.name'"
            >
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let buyer"
          class="dest-country"
          (click)="selectBuyer(buyer); toggleBuyerModal()"
        >
          {{ buyer.countryId.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="destination address">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortBuyers('address')"
        >
          <div class="table-header-wrapper">
            DESTINATION ADDRESS
            <div class="sort-controls" *ngIf="selectedSort.field === 'address'">
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div class="sort-controls" *ngIf="selectedSort.field !== 'address'">
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let buyer"
          class="dest-address"
          (click)="selectBuyer(buyer); toggleBuyerModal()"
        >
          {{ buyer.address }}
        </td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th
          mat-header-cell
          class="sortable-header"
          *matHeaderCellDef
          (click)="sortBuyers('countOfOrders')"
        >
          <div class="table-header-wrapper">
            TOTAL
            <div
              class="sort-controls"
              *ngIf="selectedSort.field === 'countOfOrders'"
            >
              <img
                src="/assets/img/icons/sort_arrow_up.svg"
                alt="up"
                *ngIf="selectedSort.mode !== 'desc'"
              />
              <img
                src="/assets/img/icons/sort_arrow_down.svg"
                alt="down"
                *ngIf="selectedSort.mode !== 'asc'"
              />
            </div>
            <div
              class="sort-controls"
              *ngIf="selectedSort.field !== 'countOfOrders'"
            >
              <img src="/assets/img/icons/sort_arrow_up.svg" alt="up" />
              <img src="/assets/img/icons/sort_arrow_down.svg" alt="down" />
            </div>
          </div>
        </th>
        <td mat-cell *matCellDef="let buyer" class="total">
          <div
            class="count-of-orders"
            [matMenuTriggerFor]="ordersList"
            #tableTrigger="matMenuTrigger"
          >
            {{ buyer.countOfOrders }}
          </div>
          <div class="orders-list">
            <mat-menu #ordersList="matMenu">
              <app-buyer-orders-modal
                *ngIf="tableTrigger.menuOpen"
                (click)="$event.stopPropagation()"
                [buyerId]="buyer.id ?? ''"
              ></app-buyer-orders-modal>
            </mat-menu>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" colspan="7">
          No data matching the filter
        </td>
      </tr>
    </table>
  </div>
  <app-paginator
    [records]="paginationData"
    (pageSettings)="getPageSettings($event)"
  ></app-paginator>
</div>

<app-edit-buyer
  [buyerForEditId]="selectedBuyer?.id"
  [companyId]="customer.id"
  (modalState)="toggleBuyerModal(); updateState($event)"
  *ngIf="isNewBuyer"
></app-edit-buyer>
